import { getRoles } from '../../../api';
import { onRequest } from '../..';
import { ActionsType } from '../../../common';
import { PropertyType } from 'esa-ui-library/lib/types';

const rolesInit = async (data: PropertyType) => {
	const roles = await getRoles(data);

	return { roles };
};

export const actions: ActionsType = {
	ROLES_INIT: (state, payload) => onRequest(() => rolesInit(payload), true),
	UPDATE_COLUMNS: (state, payload) => ({ columns: payload }),
	UPDATE_ROWS: (state, payload) => ({ rows: payload }),
	GLOBAL_ERROR: (state, payload) => ({ globalErrors: payload }),
	GLOBAL_SUCCESS: (state, payload) => ({ globalSuccess: payload }),
	MESSAGE_INVALIDATE: () => ({ globalErrors: [], globalSuccess: '' }),
};
